import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import zhCN from './locales/zh-CN.json';
import enUS from './locales/en-US.json';

// i18n 配置
i18n
  .use(LanguageDetector) // 自动检测用户语言
  .use(initReactI18next) // 初始化 react-i18next
  .init({
    resources: {
      'zh-CN': {
        translation: zhCN,
      },
      'en-US': {
        translation: enUS,
      },
    },
    fallbackLng: 'zh-CN', // 默认语言
    debug: false,
    interpolation: {
      escapeValue: false, // React 已经处理了 XSS
    },
    detection: {
      // 语言检测顺序
      order: ['localStorage', 'navigator', 'htmlTag'],
      // 缓存语言选择
      caches: ['localStorage'],
    },
  });

export default i18n;
